import React, { useEffect, useRef } from 'react'
import Icon from '@amzn/meridian/icon'
import Button from '@amzn/meridian/button'
import closeLargeTokens from '@amzn/meridian-tokens/base/icon/close-large'
import { useDispatch } from 'react-redux'
import { SiteAssistModalUtils, SAFrameId } from '@utils/SiteAssistModalUtils'
import { setSiteAssistModalHidden } from '@src/redux/slices/siteAssistModalSlice'
import { WebSocketService } from '@api/WebsocketClient'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './SiteAssistModal.css'

interface ISiteAssistModalPropsInterface {
    isSiteAssistModalOpen: boolean
}

export const SiteAssistModal = (props: ISiteAssistModalPropsInterface) => {
    const { isSiteAssistModalOpen } = props
    const [bundle] = useBundle(BUNDLE_NAME)
    const dispatch = useDispatch()
    const onClose = () => {
        dispatch(setSiteAssistModalHidden())
    }
    const siteAssistModalURL: string = SiteAssistModalUtils.getUrl()

    const iframeRef = useRef<HTMLIFrameElement>(null)
    const websocketClient = useRef<WebSocketService>(null)

    useEffect(() => {
        if (isSiteAssistModalOpen && iframeRef.current) {
            iframeRef.current?.focus()
            const connectToWebsocket = async () => {
                websocketClient.current = WebSocketService.getInstance()
                try {
                    await websocketClient.current.connect()
                } catch (e) {
                    console.error('Failed to connect to websocket', e)
                }
            }
            connectToWebsocket()
        }
        if (!isSiteAssistModalOpen) {
            if (websocketClient.current) {
                try {
                    websocketClient.current.disconnect()
                    websocketClient.current = null
                } catch (e) {
                    console.error('Failed to disconnect to websocket', e)
                }
            }
        }
    }, [isSiteAssistModalOpen, iframeRef])

    return (
        <div className={isSiteAssistModalOpen ? 'modal-overlay' : 'modal-overlay hidden'}>
            <div className={isSiteAssistModalOpen ? 'site-assist-modal' : 'modal hidden'}>
                <div className="topdiv">
                    <div className="divflex">
                        <div className="chat-header">
                        <Button size="large" type="icon" onClick={onClose} aria-label={t(bundle, 'jsma-web-navbar-closeChat')}>
                            <Icon tokens={closeLargeTokens} />
                        </Button>
                        <span className="assistant-title">{t(bundle, 'jsma-web-navbar-siteAssistant')}</span>
                        <div className="spacer" />
                        </div>
                    </div>
                    <div style={{ padding: '0px', height: 'calc(100vh - 80px)', minHeight: '400px' }}>
                        {
                            siteAssistModalURL &&
                            <iframe id={SAFrameId} ref={iframeRef} height={'100%'} width={'100%'} title={t(bundle, 'jsma-web-navbar-siteAssist')} className={'iframe'} src={siteAssistModalURL} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
